import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const nutritionistTestOptionsAdapter = createEntityAdapter({
  selectId: testOption => testOption._id,
});

export const NUTRITIONIST_TEST_INITIAL_STATE = {
  searchTextCriteria: '',
  modalityCriteria: {
    online: true,
    onsite: false,
    home: false,
  },
  roleCriteria: {
    roleName: 'fitnessGoals',
    roleSpecialty: '',
  },
  testOptions: nutritionistTestOptionsAdapter.getInitialState(),
  currentStep: 0,
  target: null,
  isSearchingByText: false,
};

export const nutritionistTestSlice = createSlice({
  name: 'wnNutritionistTest',
  initialState: NUTRITIONIST_TEST_INITIAL_STATE,
  reducers: {
    setNutritionistTestModalities: (state, action) => {
      state.modalityCriteria = action.payload;
    },
    setNutritionistTestSearchText: (state, action) => {
      state.searchTextCriteria = action.payload;
    },
    setNutritionistTestRoleCriteria: (state, action) => {
      state.roleCriteria = action.payload;
    },
    setResetNutritionistTest: (state, action) => {
      state.searchTextCriteria = '';
      state.modalityCriteria = NUTRITIONIST_TEST_INITIAL_STATE.modalityCriteria;
      state.roleCriteria = NUTRITIONIST_TEST_INITIAL_STATE.roleCriteria;
    },
    setNutritionistTestOptions: (state, action) => {
      nutritionistTestOptionsAdapter.setAll(state.testOptions, action.payload);
    },
    setNutritionistTestCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setNutritionistTestTarget: (state, action) => {
      state.target = action.payload;
    },
    setIsSearchingByText: (state, action) => {
      state.isSearchingByText = action.payload;
    }
  },
});

export const {
  setNutritionistTestModalities,
  setNutritionistTestSearchText,
  setNutritionistTestRoleCriteria,
  setResetNutritionistTest,
  setNutritionistTestOptions,
  setNutritionistTestCurrentStep,
  setNutritionistTestTarget,
  setIsSearchingByText
} = nutritionistTestSlice.actions;

export const WnNutritionistTestReducer = nutritionistTestSlice.reducer;
